import { Link } from "gatsby"
import React from "react"
import { gtmTracking } from "@/utils/gtm-tracking"

/**
 * PartnerTable
 * @param {Component} icon - Icon component
 * @param {String} title - Title of the table
 * @param {Object} data - Data to be displayed in the table
 * @param {String} footerText - Text to be displayed in the footer
 * @returns {Component} - PartnerTable component
 */
const PartnerTable = ({
  icon,
  title,
  tiers = { bronze: "Bronze", silver: "Silver", gold: "Gold" },
  data,
  footerText,
  className,
}) => {
  const gridColsClass = `2fr repeat(${
    Object.keys(tiers).length
  }, minmax(150px, 1fr)`

  const TableIcon = icon

  return (
    <div className={`partner-table ${className ?? ""}`}>
      <div className="partner-table__title">
        {icon && (
          <div className="partner-table__icon">
            <TableIcon />
          </div>
        )}

        {title && <h2 className="mb-0 mt-4 h3">{title}</h2>}
      </div>

      <div className="partner-table__table mt-10">
        <div
          className="partner-table__header"
          style={{
            display: "grid",
            gridTemplateColumns: gridColsClass,
          }}
        >
          <span className="partner-table__header__blank"></span>

          {Object.values(tiers).map((tier, index) => (
            <div key={index} className="partner-table__cell">
              {tier}
            </div>
          ))}
        </div>

        <div className="partner-table__rows">
          {data.map((row, index) => (
            <div
              key={index}
              className="partner-table__row"
              style={{
                display: "grid",
                gridTemplateColumns: gridColsClass,
              }}
            >
              <div className="partner-table__cell partner-table__row__title">
                {row.link ? (
                  <Link
                    to={row.link}
                    className="text-link text-link--bare"
                    onClick={() =>
                      gtmTracking("Link Click", row.title, "Partner Table")()
                    }
                  >
                    {row.title}
                  </Link>
                ) : (
                  row.title
                )}
              </div>

              {Object.keys(tiers).map((tier, index) => (
                <div key={index} className="partner-table__cell">
                  {typeof row[tier] === "boolean"
                    ? row[tier] && <span className="partner-table__dot"></span>
                    : row[tier]}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {footerText && (
        <p className="partner-table__footer mb-0 p--sm mt-4">{footerText}</p>
      )}
    </div>
  )
}

export default PartnerTable
